<template>
	<rengongcuipingHeader checktab="RengongYlqRw" />
	<p>
		领取时间范围：<a-config-provider :locale="locale">
			<a-range-picker v-model:value="timestr" :placeholder="placeholder" @openChange="openChange" @focus="focusChange" show-time :size="size" />
		</a-config-provider>

		旗帜：
		<a-select
			ref="select"
			v-model:value="qizhivalue"
			style="width: 120px"
			:size="size">
			<a-select-option value="7">不限制</a-select-option>
			<a-select-option value="6">非插旗</a-select-option>
			<a-select-option value="0">
				<flag-outlined style="margin-right: 2px;" />灰旗</a-select-option>
			<a-select-option value="1">
				<flag-outlined style="color:rgb(126, 6, 238);margin-right: 2px;" />紫旗</a-select-option>
			<a-select-option value="2">
				<flag-outlined style="color:rgb(118, 238, 6);margin-right: 2px;" />青旗</a-select-option>
			<a-select-option value="3">
				<flag-outlined style="color:rgb(6, 238, 83);margin-right: 2px;" />绿旗</a-select-option>
			<a-select-option value="4">
				<flag-outlined style="color:rgb(238, 164, 6);margin-right: 2px;" />橙旗</a-select-option>
			<a-select-option value="5">
				<flag-outlined style="color:rgb(238, 6, 6);margin-right: 2px;" />红旗</a-select-option>
		</a-select>
		&nbsp;&nbsp;
		飞鸽发送状态：
		<a-select
			ref="select"
			v-model:value="feigeStatusvalue"
			style="width: 120px"
			:size="size">
			<a-select-option value="all">全部</a-select-option>
			<a-select-option value="false">未发送</a-select-option>
			<a-select-option value="true">已发送</a-select-option>
		</a-select>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		<a href="/cuipingylqrw.php" target="_blank">使用旧版</a>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		<a @click="deleteMul">批量删除</a>
		&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		<a @click="piliangfeigemsg2">旧版飞鸽</a>
	</p>
	<p>
		订单ID:
		<a-input v-model:value="parent_order_id" :size="size" class="inlineblock" />

		商品ID:
		<a-input v-model:value="product_id" :size="size" class="inlineblock" />
		沟通状态：<a-select
					v-model:value="goutongvalue"
					style="width: 120px"
					:size="size"
					:options="goutongoptions">
			<a-select-option v-for="item in goutongoptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
		</a-select>
		催评客服：

		<a-select
				:size="size"
				style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
				:options="kefuoptions"
				v-model:value="kefuname"
				id="kefuname"
				class="kefuname">
			<a-select-option v-for="item in kefuoptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
		</a-select>

		每页显示：<a-select
					v-model:value="pageSize"
					style="width: 120px"
					:size="size"
					@change="handlePageSizeChange">
			<a-select-option value="100">100</a-select-option>
			<a-select-option value="200">200</a-select-option>
			<a-select-option value="300">300</a-select-option>
		</a-select>
		共<span>{{ totalPageNum }}</span>页 <span>{{ paginationtotal }}</span>条
		<a-button type="primary" shape="" :size="size" style="margin-left: 4px;" @click="getRgcp_Renwu_Qs()">
			搜索
		</a-button>
	</p>

	<a-modal v-model:visible="visiblelingqu" title="客服领取" @ok="lingquaction" cancelText="取消" okText="确认">
		<p>领取数量：
			<a-input v-model:value="lingqunum" placeholder="" class="inlineblock" />可领取{{ kelingqunum }} 条</p>
		<p>客服名称：
			<a-input v-model:value="lingqukefu" placeholder="请输入客服名称" class="inlineblock" />
		</p>
	</a-modal>
	<a-modal v-model:visible="visiblelingqusigle" title="客服领取" @ok="lingqurenwuaction" cancelText="取消" okText="确认">
		<p>客服名称：
			<a-input v-model:value="lingqukefu" placeholder="请输入客服名称" class="inlineblock" />
		</p>
	</a-modal>


	<div style="margin:4px 0;">
		<a-popover placement="bottom">
			<template #content>
				<a-checkbox-group v-model:value="visibletablecol" style="width: 100%" @change="zhanshilie">
					<p v-for="item in oldcolumns" :key="item.dataIndex">
						<a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
					</p>
				</a-checkbox-group>
			</template>
			<template #title>
				<span>表格展示列</span>
			</template>
			<align-left-outlined style="color:#666;font-size: 24px;" />
		</a-popover>
	</div>
	<div class="paginationdiv">
		<a-pagination v-model:current="current" v-model:pageSize="pageSize" v-model:total="paginationtotal" :onChange="onPageChange" :size="size" :showSizeChanger="false" />
	</div>
	<a-table v-model:dataSource="dataSource" :columns="columns" :size="size" rowKey="id" :pagination="false" bordered>
		<template #headerCell="{ column }">
			<template v-if="column.key === 'xuhao'">
				<span>

					全选
				</span>
				<br />
				<span>
					<a-checkbox v-model:checked="checkboxchecked" :indeterminate="indeterminate" @change="checkAllchange" />
				</span>
			</template>
			<template v-if="column.key === 'feige_link'">
				<span>

					{{ column.title }}

				</span>
				<!--p>
					<a @click="piliangfeigemsg">批量飞鸽</a>
				</p-->
			</template>
			<template v-if="column.key === 'tel_link'">
				{{ column.title }}
				<p>
					点小眼睛可查看<span style="color:red">近期签收的</span>电话
				</p>
			</template>
			<template v-if="column.key === 'parent_order_id'">
				<p style="text-align:center;">

					{{ column.title }}
					<br>
					<a @click="tan_goodPldownload">批量下载</a>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<a @click="piliangPrintOrder(true,'')">批量打单</a>
				</p>
			</template>
			<template v-if="column.key === 'sms'">
				<div>
					{{ column.title }}
				</div>
				<div>
					<a @click="piliangduanxin">批量短信</a>

				</div>
			</template>
			<template v-if="column.key === 'beizhu'">

				<p>
					<a @click="piliangbeizhu">{{ column.title }}</a>
				</p>
			</template>
		</template>
		<template v-slot:bodyCell="{ column, record }">
			<template v-if="column.key === 'xuhao'">
				<p>{{ record.xuhao }}
					<a-checkbox :checked="record.checked" @change="checkboxchange" :value="record.parent_order_id" />
				</p>

			</template>
			<template v-if="column.key === 'renling_time'">
				<p>{{ record.renling_time }}
					<br />
					<a @click="paichufasong(record.parent_order_id)">删除</a>
				</p>

			</template>
			<template v-if="column.dataIndex === 'product'">
				<div v-for="item in record.productDesc" :key="item.id" style="margin: 4px 0;">
					<div style="float: left;">
						<a-image
						:width="80"
						:src="item.product_pic" />
					</div>
					<div style="text-align:left;float: left;width:154px">{{ item.product_name }}
						<br>
						<span v-if="!isNaN(item.order_amount)">
							金额：{{ (item.order_amount/100).toFixed(2) }}
						</span> 
					</div>
					
					<div style="clear: both;"></div>
				</div>
			</template>
			<template v-if="column.dataIndex === 'all_amount'">
				<span v-if="!isNaN(record.all_amount) && record.all_amount != null">{{ (record.all_amount/100).toFixed(2) }}</span>
			</template>
			<template v-if="column.dataIndex === 'address'">
				<span> {{record.province_name}}</span>
				<br />
				<span> {{record.city_name}}</span>
				<br />
				<span> {{record.town_name}}</span>
			</template>
			<template v-if="column.dataIndex === 'order_status_desc'">
				<p> {{record.order_status_desc}}{{record.ship_day}}</p>
			</template>
			
			<template v-if="column.key === 'sms'">
				<a @click="fasongduanxin(record.parent_order_id)">发送短信</a>
			</template>
			<template v-if="column.key === 'feige_link'">
				<p v-if="record.feige_link=='true'">已做</p>
				<p v-if="record.feige_link=='false'">
					<span style="color:red;">未做</span>
				</p>

				<p>
					<a :href="record.feige_url" target="_blank" @click="updatefeige(record.parent_order_id)">
						点击沟通
					</a>
				</p>

			</template>

			<template v-if="column.key === 'tel_link'">
				<p v-if="record.tel_link=='true'">已做</p>
				<p v-if="record.tel_link=='false'">
					<span style="color:red;">未做</span>
				</p>
				<p v-if="record.tel">
					{{ record.tel }}
					<br>
					<span v-if="record.iscopy=='true'">已复制</span>
					<copy-outlined  @click="copytel(record.tel,record.parent_order_id) " style="color:rgb(6, 79, 238);margin-right: 2px;" />
				</p>
				<a v-else>
					<p v-if="record.loading == 'true'">
						加载中。。。
					</p>					
					<p v-else>
						<BodyGuard :data="record.jiemiData"  class="jiemiDataEle" @click="jiludata(record.parent_order_id,record.staffName) "/>
					</p>
				</a>
				
				

			</template>
			<template v-if="column.key === 'parent_order_id'">
				<p style="text-align: center;">{{ record.parent_order_id }}</p>
				<p style="text-align: center;">
					<a @click="piliangPrintOrder(false,record.parent_order_id) " style="margin-right: 8px;" >打印</a>
					<a @click="copyurl(record.parent_order_id) " style="margin-right: 8px;" >复制</a>
					<!--a @click="yulan(record.parent_order_id) " style="margin-right: 8px;" >预览</a-->
				</p>
			</template>
			<template v-if="column.dataIndex === 'beizhu'">

				<div>
					<a-textarea v-model:value="record.kefubeizhu" :row="4" @blur="wanchengxiugaibeizhu(record.kefubeizhu,record.parent_order_id)" />
				</div>
			</template>
		</template>
	</a-table>
	<div class="paginationdiv">
		<a-pagination v-model:current="current" v-model:pageSize="pageSize" v-model:total="paginationtotal" :onChange="onPageChange" :size="size" :showSizeChanger="false" />
	</div>
	<a href="" target="_blank" id="clickopena">
		<span id="clickopen"></span>
	</a>
	<a-modal v-model:visible="visible" title="请先安装插件" @ok="handleOk" cancelText="取消" okText="确定">
		<p>请先下载安装浏览器插件后，再来操作！</p>
		<p>
			<a href="/file/feige_order_msg.zip" target="_blank">点此下载插件</a>
		</p>
	</a-modal>
	<a-modal v-model:visible="visible2" title="发送消息" @ok="handleOk2" cancelText="取消" okText="发送">
		<p>请输入发送内容：</p>
		<p>
			<a-textarea :rows="4" placeholder="发送内容最多100字" v-model:value="fasong_content" :maxlength="100" />
		</p>
	</a-modal>
	
	<a-modal v-model:visible="tan_goodPldownloadvisible" title="批量下载" @ok="tan_goodPldownloadACT" cancelText="取消" okText="下载">
		<p>
			
			<a-radio-group v-model:value="tan_goodPldownloadACTValue" name="radioGroup">
				<p>
					<a-radio value="check">当前已勾选的订单</a-radio>
				</p>
				<p>
					<a-radio value="all">下载全部符合条件的订单</a-radio>
				</p>
			</a-radio-group>
		</p>
	</a-modal>
	<a-modal v-model:visible="visible3" title="批量发送消息" @ok="handleOk3" cancelText="取消" okText="发送">
		<p>发飞鸽客服：
			<select
					:size="size"
					style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
					:options="kefuoptions2"
					id="fakefuname"
					class="fakefuname">
				<option v-for="item in kefuoptions2" :key="item.value" :value="item.value">{{ item.label }}</option>
			</select>
		</p>
		<p>发送间隔：
			<a-input v-model:value="fsshijian" type="number" min="5" style="width: 70px;" />秒
		</p>
		<p>发飞鸽模板：
			<select
					:size="size"
					style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
					:options="Planoptions"
					id="fafeigePlan"
					class="fakefuname">
				<option v-for="item in Planoptions" :key="item.value" :value="item.value">{{ item.label }}</option>
			</select>
			<RouterLink to="/RengongFeigeMessageList">点此前去创建</RouterLink>
		</p>
		<p>
			发 送 订 单 ：
			<a-radio-group v-model:value="messageOrderValue" name="radioGroup">
				<p>
					<a-radio value="selectList">当前已勾选的订单</a-radio>
				</p>
				<p>
					<a-radio value="allList">所有已领取未发送过此飞鸽模版的订单</a-radio>
				</p>
			</a-radio-group>
		</p>
		<p>提示：一个订单只会发送一次消息，不用担心重复发送。</p>
	</a-modal>
	<a-modal v-model:visible="visibleYaoping" title="批量邀评" @ok="piliangyaoping" cancelText="取消" okText="发送">
		<p>
			发 送 订 单 ：
			<a-radio-group v-model:value="yaopingValue" name="radioGroup">
				<p>
					<a-radio value="selectList">当前已勾选的订单</a-radio>
				</p>
				<p>
					<a-radio value="allList">所有已领取未发送邀评卡的可催评订单</a-radio>
				</p>
			</a-radio-group>
		</p>
		<p>提示：使用本软件一个买家只发送一次邀评信息，不必担心 重复发送。</p>
	</a-modal>
	<a-modal v-model:visible="visiblePrintOrderData" title="批量打单" @ok="closepiliangPrint" cancelText="取消" okText="确定">
		{{ PrintOrderData  }}
	</a-modal>
	<a-modal v-model:visible="visiblePrintOrder" title="批量打单" @ok="piliangPrintOrderAct" cancelText="取消" okText="发送">
		<p>发货人：
			<select
					:size="size"
					style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
					:options="fahuoRenoptions"
					id="fahuoRenoptions"
					class="fakefuname">
				<option v-for="item in fahuoRenoptions" :key="item.id" :value="item.id">{{ item.sendName }}</option>
			</select>&nbsp;&nbsp;
			<router-link :to="{ path: 'DzmdTempMan'}">编辑发货人</router-link>
		</p>
		<p>快递模板：
			<select
					:size="size"
					style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
					:options="kuaidiTempoptions"
					id="kuaidiTempoptions"
					class="fakefuname">
				<option v-for="item in kuaidiTempoptions" :key="item.template_id" :value="item.template_code">{{ item.template_name }}</option>
			</select>&nbsp;&nbsp;
			<router-link :to="{ path: 'DzmdTempMan'}">编辑模板</router-link>
		</p>
		<p>打印机：
			<select
					:size="size"
					style="width: 120px; height: 24px;background-color: #fff;border-color: #e3e3e3;"
					:options="Printeroptions"
					id="Printeroptions"
					class="fakefuname">
				<option v-for="item in Printeroptions" :key="item.name" :value="item.name">{{ item.name }}</option>
			</select>&nbsp;&nbsp;
			<a href="https://fuwu.jinritemai.com/optimus/617a41e010db430045ca942d" target="_blank">去下载抖店官方打印组件</a>
		</p>
	</a-modal>
	<a-modal v-model:visible="NoPlanvisible" title="还未创建飞鸽消息模板" @ok="handleOkNoPlan" cancelText="关闭" okText="前去创建">
		<p>您还未创建飞鸽消息模板, <RouterLink to="/RengongFeigeMessageList">点此前去创建</RouterLink>
		</p>
	</a-modal>
	<a-modal v-model:visible="visible4" title="飞鸽发送进度" @ok="handleOk4" cancelText="取消" okText="确定">
		<p>正在发送......请勿关闭页面！</p>
		<p>
			共{{ pilnum }} 个消息，正在发送第{{ fpilnum }}个
		</p>
	</a-modal>
	<a-modal v-model:visible="visible5" title="提示" @ok="handleOk5" cancelText="取消" okText="查看教程">
		<p>请在百灵软件打开商鱼，才可以自动发送飞鸽消息。</p>
	</a-modal>
	<a-modal v-model:visible="jiaochengbisible" title="如何使用其他店铺的话费发短信？" @ok="closeModal" width="600px" cancelText="取消" okText="确认">
		<p>
			<a-image :src="require('@/assets/images/gxhf.png')" width="550px" />
		</p>
	</a-modal>
	<a-modal v-model:visible="visiblebailing" title="提示" @ok="handleOkbailing" cancelText="取消" okText="前去下载">
		<p>请在好评大师进行此操作，如果您未安装好评大师，请进行下载安装</p>
	</a-modal>
	<a-modal v-model:visible="visiblebailing2" title="提示" @ok="handleOkbailing" cancelText="取消" okText="前去下载">
		<p>百灵工作台已进行升级，请卸载现在的旧版本，下载安装最新版本进行使用。</p>
	</a-modal>
	<a-modal v-model:visible="visible6" title="注意" @ok="handleOk6" cancelText="已知晓" okText="确定">
		<p>1、请确保您是在百灵软件中进行飞鸽消息发送，否则发送飞鸽消息不成功。</p>
		<p>2、您可以切换其他店铺，继续进行其他店铺飞鸽消息发送配置。百灵软件支持多店铺同时发送飞鸽消息。</p>
		<p>3、请不要关闭或者最小化百灵软件，否则发送飞鸽消息不成功。</p>
	</a-modal>
	<a-modal v-model:visible="visible31" title="批量发送消息" @ok="handleOk31" cancelText="取消" okText="发送">
		<p>请输入发送内容：</p>
		<p>
			<a-textarea :rows="4" placeholder="发送内容最多100字" v-model:value="fasong_content" :maxlength="100" />
		</p>

	</a-modal>
	<a-modal v-model:visible="beizhuvisible" title="批量修改备注" @ok="piliangbeizhuAct" cancelText="取消" okText="确定">
		<p>请输入备注内容</p>
		<p>
			<a-input v-model:value="plbeizhustr" />
		</p>
	</a-modal>
	<a-modal v-model:visible="deletevisible" title="批量删除" @ok="piliangdelAct" cancelText="取消" okText="确定">
		<p>确定要批量删除吗？</p>
	</a-modal>
	<a-modal v-model:visible="visiblecreatfeige" title="提示" @ok="closevisiblecreatfeige" cancelText="取消" okText="确定">
		<span>您可以继续添加消息等操作，也可以把这个页面最小化。但是不要关闭抖店和这个页面，否则消息发送可能失败。</span>
	</a-modal>
	<a-modal v-model:visible="visibleSmsTemp" title="批量发短信" style="width:680px;max-height:700px;" @ok="piliangSmsAct" cancelText="取消" okText="开始发送">
	<div style="width:654px;max-height:660px;overflow-y:scroll;">
		<p>
              短信扣费账号：
              <a-radio-group value="shopName_fee">
                <a-radio value="shopName_fee">{{shopName_fee}}</a-radio>
              </a-radio-group>
              {{duanxintiao}}条
              <router-link to="/SmsFeeChange">点击充值提升可发送条数</router-link> (<a style="color:rgb(4, 192, 29);" @click="chakanjiaocheng">如何使用其他店铺的话费发短信？</a>)
            </p>
		<p>
              短信签名：<span class="dianjixingdong" @click="gotosmssign">+点击创建短信签名</span>
            </p>
			<div style=" margin-right: 8px;margin-left: 68px;">
						<a-radio-group v-model:value="setduanxinSms" @change="setduanxinAct">
							<a-radio v-for="item in signList " :style="radioStyle" :key="item.sign" :value="item.sign">
							<span style="display:inline-block;min-width:120px;">{{ item.sign }}</span>&nbsp;
							
							</a-radio>
						</a-radio-group>
					</div>
					<div class="clr">
					</div>
			<div>
				<div style="">
					短信内容：<span class="dianjixingdong" @click="gotosmstemp">+点击创建短信模板</span>
				</div>
				
              <div style="width:460px;  margin-right: 8px;margin-left: 68px;">
                <div>
					<a-radio-group v-model:value="setduanxin" @change="setduanxinAct">
						<a-radio v-for="item in duanxinlist "  :key="item.sms_template_id" :value="item.sms_template_id">{{ item.template_content }}</a-radio>
					</a-radio-group>
                </div>
              </div>
            </div>
            </div>
            
	</a-modal>
</template>
<script>
import { computed, defineComponent, reactive,    ref, toRefs } from 'vue';
import { BodyGuard } from '@open-fxg/bodyguard-vue'
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import { FlagOutlined , SearchOutlined , CopyOutlined,AlignLeftOutlined, CopyrightOutlined } from '@ant-design/icons-vue';
import moment from 'moment'

import  rengongcuipingHeader from '@/components/rengongcuiping/RengongcuipingHeader.vue';

import {getMainShop , getDuanxinNum ,getSmsNamesPro ,getSmsTemplatePro , getPrTemplateNEW,getPrSendInfoNEW,sendOrder,tijiaoprint, 
order_getRgcp_Renwu_Q, getFeigePlan, getRGCPOrdersSize,delOrder,lingquAll,lingqu, 
comment_getDecryptTel, 
paichu_delOrderCeshi,
getRgcp_Renwu_QCeshi, 
getKefuCeshi,
comment_getDecryptTokenCeshi,
comment_updateBeizhuCeshi,
comment_updateTelLinkCeshi, 
comment_PLupdateBeizhuCeshi,
comment_updateOrderCeshi, 
comment_updateFeigeCeshi, 
comment_delOrder} from '@/request/api';


import CommonConfig from '@/components/config/CommonConfig'


import zh_CN from 'ant-design-vue/es/locale/zh_CN';

import $ from 'jquery'

export default defineComponent({
  
  components:{
    rengongcuipingHeader,
    FlagOutlined,
    AlignLeftOutlined,
    CopyOutlined,
	BodyGuard
  },
  setup() {
    const datas = {"total":1266,"current":1,"size":100,"records":[{"post_receiver":"","qianshou_time":"2023-05-23 09:06:38","logistics_receipt_time":"2023-05-23 09:06:38","address":"河南省_郑州市_二七区","create_time":"2023-05-21 15:34:19","ship_time":"2023-05-21 21:11:28","tel_link":"true","ship_day":"0天","province_name":"河南省","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p9-aio.ecombdimg.com/obj/ecom-shop-material/wDzWntqO_m_fb5f09093541e433dbf87a15a610bb6a_sx_943146_www2500-2500","product_id":"3608495202303612029","sku_id":"1765519196739692","product_name":"夏春茶玫红色裤子工装裤女夏季宽松阔腿裤甜酷高腰束脚裤休闲裤子","spec":"[{\"name\":\"颜色分类\",\"value\":\"玫红色\"},{\"name\":\"尺寸\",\"value\":\"M（身高160-165cm）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"郑州市","kefubeizhu":"nodata","comment_desc":"false","town_name":"二七区","all_amount":"78.00","feige_link":"true","staffName":"曹雪","order_link":"true","id":"fd5bcb2de8193f8bbf97660e8d6062eb38a2535155d6704ae7f9877023f1786b","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918641751744714714"},{"post_receiver":"","qianshou_time":"2023-05-23 10:45:09","logistics_receipt_time":"2023-05-23 10:45:09","address":"江苏省_南京市_秦淮区","create_time":"2023-05-22 07:50:24","ship_time":"2023-05-22 14:37:38","tel_link":"true","ship_day":"0天","province_name":"江苏省","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p6-aio.ecombdimg.com/obj/ecom-shop-material/wDzWntqO_m_2bf4fe702b63551bf664bfc83f14e283_sx_948939_www2500-2500","product_id":"3611673448105036871","sku_id":"1765515761586220","product_name":"夏春茶街拍潮酷束腰工装裤嘻哈直筒裤夏季口袋设计束腿休闲裤女","spec":"[{\"name\":\"颜色分类\",\"value\":\"军绿色\"},{\"name\":\"尺寸\",\"value\":\"L（适合身高166-178cm）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"南京市","kefubeizhu":"nodata","comment_desc":"false","town_name":"秦淮区","all_amount":"78.00","feige_link":"true","staffName":"曹雪","order_link":"true","id":"fc806707474d5b991798b50d7efb0b9a0016447c2d1ae396850cdb7dcf0ed0a0","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918654098115269642"},{"post_receiver":"","qianshou_time":"2023-05-23 10:29:32","logistics_receipt_time":"2023-05-23 10:29:32","address":"广东省_惠州市_惠阳区","create_time":"2023-05-21 15:55:00","ship_time":"2023-05-21 17:56:20","tel_link":"true","ship_day":"0天","province_name":"广东省","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p6-aio.ecombdimg.com/obj/ecom-shop-material/wDzWntqO_m_2bf4fe702b63551bf664bfc83f14e283_sx_948939_www2500-2500","product_id":"3611673448105036871","sku_id":"1765515761586220","product_name":"夏春茶街拍潮酷束腰工装裤嘻哈直筒裤夏季口袋设计束腿休闲裤女","spec":"[{\"name\":\"颜色分类\",\"value\":\"军绿色\"},{\"name\":\"尺寸\",\"value\":\"L（适合身高166-178cm）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"惠州市","kefubeizhu":"nodata","comment_desc":"false","town_name":"惠阳区","all_amount":"78.00","feige_link":"true","staffName":"曹雪","order_link":"true","id":"fb442349e89fbb94b72046b3d1d0b29e0a7cb9133df5fdd01cf4e7c1eec81294","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918618969529718599"},{"post_receiver":"","qianshou_time":"2023-05-23 11:04:32","logistics_receipt_time":"2023-05-23 11:04:32","address":"浙江省_温州市_鹿城区","create_time":"2023-05-22 09:00:22","ship_time":"2023-05-22 15:32:34","tel_link":"true","ship_day":"0天","province_name":"浙江省","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p3-aio.ecombdimg.com/obj/ecom-shop-material/wDzWntqO_m_0681e83684e5b5810741e6eaa5f27a1b_sx_959598_www2500-2500","product_id":"3608495202303612029","sku_id":"1765519196739660","product_name":"夏春茶玫红色裤子工装裤女夏季宽松阔腿裤甜酷高腰束脚裤休闲裤子","spec":"[{\"name\":\"颜色分类\",\"value\":\"牛油果绿\"},{\"name\":\"尺寸\",\"value\":\"L（身高165-175cm）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"温州市","kefubeizhu":"nodata","comment_desc":"false","town_name":"鹿城区","all_amount":"78.00","feige_link":"true","staffName":"曹雪","order_link":"true","id":"f8ae17b2b9c22ac0fb1640ac64ccb5c309f5afe54414eab971d39a487802696d","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918685205326861712"},{"post_receiver":"","qianshou_time":"2023-05-23 10:44:33","logistics_receipt_time":"2023-05-23 10:44:33","address":"上海市_上海市_闵行区","create_time":"2023-05-22 07:39:34","ship_time":"2023-05-22 14:58:01","tel_link":"true","ship_day":"0天","province_name":"上海市","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p9-aio.ecombdimg.com/obj/ecom-shop-material/wDzWntqO_m_09e691f217a97a8a2a9be4874b2584e0_sx_914311_www2500-2500","product_id":"3608495202303612029","sku_id":"1765519196741696","product_name":"夏春茶玫红色裤子工装裤女夏季宽松阔腿裤甜酷高腰束脚裤休闲裤子","spec":"[{\"name\":\"颜色分类\",\"value\":\"烟熏玫瑰粉\"},{\"name\":\"尺寸\",\"value\":\"M（身高160-165cm）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"上海市","kefubeizhu":"nodata","comment_desc":"false","town_name":"闵行区","all_amount":"78.00","feige_link":"false","staffName":"曹雪","order_link":"true","id":"f6de3570b43cf5060e48e248619adf932d336bdf6118528d7872f2901158e62c","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918671794361472757"},{"post_receiver":"","qianshou_time":"2023-05-23 11:56:16","logistics_receipt_time":"2023-05-23 11:56:16","address":"江苏省_苏州市_吴江区","create_time":"2023-05-21 18:27:27","ship_time":"2023-05-22 14:09:37","tel_link":"true","ship_day":"0天","province_name":"江苏省","sms_time":"1970-01-01 08:00:00","productDesc":[{"product_pic":"https://p9-aio.ecombdimg.com/obj/ecom-shop-material/v1_wDzWntqO_70962895500790991710862_4a479746b6da84e41c435ab6a34ec252_sx_638401_www2500-2500","product_id":"3542604850724514130","sku_id":"1763575103479848","product_name":"夏春茶辣妹设计感小众无袖运动背心女内搭短款打底吊带上衣夏季潮","spec":"[{\"name\":\"颜色分类\",\"value\":\"黑色\"},{\"name\":\"尺码\",\"value\":\"L（110-120斤）\"},{\"name\":\"发货时效\",\"value\":\"5天内发货\"}]"}],"city_name":"苏州市","kefubeizhu":"nodata","comment_desc":"false","town_name":"吴江区","all_amount":"38.00","feige_link":"false","staffName":"曹雪","order_link":"true","id":"f46e792c6779853ef7fa5e482290083fce5b627afd1f5134e810fd94bf32d567","renling_time":"2023-05-23 13:58:53","order_status_desc":"已签收","parent_order_id":"6918655555506017470"}],"totalPage":13}
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const visibletablecol = ref(['sms','logistics_receipt_time','order_status_desc','xuhao', 'product', 'address',   'feige_link', 'staffName', 'comment_descstr', 'renling_time', 'parent_order_id', 'tel_link', 'beizhu']);
    return { 
		kefuoptions:ref([{value:"all",label:'全部'}]),
		kefuoptions2:ref([{value:"all",label:'请选择'}]),
		Planoptions:ref([{value:"all",label:'请选择'}]),
		goutongoptions:[{value:"all",label:'全部'},{value:"false",label:'未沟通'},{value:"true",label:'已沟通'}],
		ws:{},
		datas,
		dateFormat,
		SearchOutlined , 
		size:'small',
		visibletablecol
    };
  },
  props:[],
  created () {
    this.getKefuact()
    this.getPlanList()
    this.settimestr()
    this.getfhinfo() 
    this.getTempleteList()
	getDuanxinNum().then(res=>{
        that.duanxintiao = res.data
      })
	getSmsNamesPro().then(res=>{
		if(res.data.length > 0){
			this.setduanxinSms = res.data[0].sign
		}
		this.signList = res.data;
	})
	getSmsTemplatePro().then(res=>{
		this.duanxinlist = res.data        
	})
	getMainShop().then(res=>{
		this.shopName_fee = res.data        
	})
    let that = this;
    window.openorderim = this.openorderim
    window.setTodayTime = this.setTodayTime
    setInterval(function(){
      if($("#fasongwancheng").length > 0){
        let fasongwancheng = $("#fasongwancheng").val()
        if(fasongwancheng == 1){
          $("#fasongwancheng").val(0)
          that.openorderimsuccess();
        }
        let openorderimfail = $("#openorderimfail").val()
        if(openorderimfail != 0){
          $("#openorderimfail").val(0)
          that.openorderimfail(openorderimfail);
        }
      }     
    },500);
  },
  data(){ 
    let that  = this   
    return{
		pageRow:1,
		product_id:'',
		pageSize:100,
		paginationtotal:0,
		dataSource:[],  
		timestr:ref(),
		fsshijian:ref(5),
		locale:zh_CN,
		placeholder:['开始时间','结束时间'],
		currentTimeInput:0,
		qizhivalue:ref("7"),
		feigeStatusvalue:ref('all'),
		goutongvalue:ref(),
		totalPageNum:'0',
		visiblelingqu:ref(false),
		visiblelingqusigle:ref(false),
		lingqukefu:'',
		lingqunum:'',
		kelingqunum:0,
		lingquorder_id:'',
		parent_order_id:'',
		visible:ref(false),
		visible2:ref(false),
		visible3:ref(false),
		visible4:ref(false),
		visible31:ref(false),
		visible5:ref(false),
		visible6:ref(false),
		visiblebailing:ref(false),
		visiblebailing2:ref(false),
		beizhuvisible:ref(false),
		deletevisible:ref(false),
		visibleSmsTemp:ref(false),
		fasongduanxinAct:ref(false),
		fasongduanxinActID:'',
		smsTempoptions:[{id:'all',proName:'请选择'}],
		setduanxin:ref(''),
		setduanxinSms:ref(''),
		jiaochengbisible:ref(false),
		tan_goodPldownloadvisible:ref(false),
		tan_goodPldownloadACTValue:ref('check'),
		plbeizhustr:'',
		imorder_id:'',
		fasong_content:'',
		kefuname:ref('all'),
		pilint:0,
		sendmessageOn:ref(true),
		checklist:[],
    orderListNum:0,
		pilnum:0,
		fpilnum:0,
		currentPageTotal:0,
		checkboxchecked:ref(false),
		indeterminate:ref(false),
		timeRange:CommonConfig.components.timeRange,
		messageOrderValue:ref('selectList'),
		NoPlanvisible:ref(false),
		visibleYaoping :ref(false),
		yaopingValue : ref("selectList"),
		fafeigePlanvalue:ref('all'),
		fakefuvalue:ref('all'),
		visiblecreatfeige:ref(false),
		valuekefu:ref('all'),
		valuefeige:ref('all'),
		kuaidiTempoptions:[],
		fahuoRenoptions:[{id:'all',sendName:'请选择'}],
		Printeroptions:[{value:'all',name:'请选择'}],
		visiblePrintOrder:ref(false),
		visiblePrintOrderData:ref(false),
		PrintOrderData:ref(''),
		templatevalue:'yd_100_180_v2',
		printervalue:'all',
		lianjiedayinjistatus:false,
		piliangPrintOrderStatus:ref(false),
		yulanValue:ref(false),
		yulandayinid:'',
		shopName:ref(''),
		duanxintiao:ref(''),
		duanxinlist:ref([]),
		wenbentext:ref(''),
		sms_template_name:ref(''),
		signList:ref([]),
      oldcolumns:[
      {
          title: '序号',
          dataIndex: 'xuhao',
          key: 'xuhao',
          width:'60px'
        },
        {
          title: '商品',
          dataIndex: 'product',
          key: 'product',
          width:'254px',
          
        },
        {
          title: '收货地址',
          dataIndex: 'address',
          key: 'address',
        },
        {
          title: '签收时间',
          dataIndex: 'logistics_receipt_time',
          key: 'logistics_receipt_time',
          width: '90px'
        },
        {
          title: '物流状态',
          dataIndex: 'order_status_desc',
          key: 'order_status_desc',
        },
        {
          title: '客服领任务时间',
          dataIndex: 'renling_time',
          key: 'renling_time',
          width: '90px'       
        },

        
        {
          title: '评论状态',
          dataIndex: 'comment_descstr',
          key: 'comment_descstr',
          
        },
        {
          title: '催评客服',
          dataIndex: 'staffName',
          key: 'staffName',          
        },
        {
          title: '短信通知',
          dataIndex: 'sms',
          key: 'sms',          
        },
        {
          title: '订单号',
          dataIndex: 'parent_order_id',
          key: 'parent_order_id',
          
        },
        {
          title: '飞鸽联系',
          dataIndex: 'feige_link',
          key: 'feige_link',
          width:'76px'
        },
        {
          title: '电话联系',
          dataIndex: 'tel_link',
          key: 'tel_link',
          width:'106px'
          
        },
        {
          title: '批量备注',
          dataIndex: 'beizhu',
          key: 'beizhu',
          
        }
      ],
      columns: [
      {
          title: '序号',
          dataIndex: 'xuhao',
          key: 'xuhao',
          width:'60px'
        },
        {
          title: '商品',
          dataIndex: 'product',
          key: 'product',
          width:'254px',
          
        },
        {
          title: '收货地址',
          dataIndex: 'address',
          key: 'address',
        },
        {
          title: '签收时间',
          dataIndex: 'logistics_receipt_time',
          key: 'logistics_receipt_time',
          width: '90px'
        },
        {
          title: '物流状态',
          dataIndex: 'order_status_desc',
          key: 'order_status_desc',
        },
        {
          title: '客服领任务时间',
          dataIndex: 'renling_time',
          key: 'renling_time',
          width: '90px'        
        },

        
        {
          title: '评论状态',
          dataIndex: 'comment_descstr',
          key: 'comment_descstr',
          
        },
        {
          title: '催评客服',
          dataIndex: 'staffName',
          key: 'staffName',
          
        },
        {
          title: '短信通知',
          dataIndex: 'sms',
          key: 'sms',          
        },
        {
          title: '订单号',
          dataIndex: 'parent_order_id',
          key: 'parent_order_id',
          
        },
        {
          title: '飞鸽联系',
          dataIndex: 'feige_link',
          key: 'feige_link',
          width:'76px'
        },
        {
          title: '电话联系',
          dataIndex: 'tel_link',
          key: 'tel_link',
          width:'106px'
          
        },
        {
          title: '批量备注',
          dataIndex: 'beizhu',
          key: 'beizhu',
          
        }
      ],
      pagination:{
        position:`bottomcenter`,
        pageNo: 1,
        pageSize: that.pageSize, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        pageSizeOptions: ['100','200','300'], // 每页数量选项
        showTotal: total => ``, // 显示总数共 ${total} 条
        onShowSizeChange: (current, pageSize) => that.onSizeChange(current, pageSize), // 改变每页数量时更新显示
        onChange:(page,pageSize)=>that.onPageChange(page,pageSize),//点击页码事件
        total:that.paginationtotal //总条数
      },
      guanfangToken:'',
      columnsJiemi:[
      {
          title: '序号',
          dataIndex: 'jiemi',
          key:'jiemi',
          width:'160px'
        },
      ]
    }
  },
  methods:{
	jiludata(parent_order_id,staffName){
		let data = {
			parent_order_id:parent_order_id,
			staffName:staffName
		}
		comment_updateTelLinkCeshi(data).then(res=>{})
	},
	getjiemiToken(){
		comment_getDecryptTokenCeshi().then(res => {
			this.guanfangToken = res;
		})
    },
    handlePageSizeChange(value){
      this.pageSize = value;
    },
    zaixianlieact(value){
     console.log(value)

    },
    handleGouTongChange(value){
      //console.log(value)
      this.goutongvalue = ref(value)
    },
    onSizeChange(current, pageSize){
      //console.log(current, pageSize)
    },
    onPageChange(page,pageSize){
      //console.log(page, pageSize)
      this.pageRow = page;
      this.getRgcp_Renwu_QCeshi();

    },
    /*pagination() {
       return{ 
       
       }
      },*/
     onChange  (value, dateString)  {
      /*console.log('Selected Time: ', value);
      console.log('onChange Formatted Selected Time: ', dateString);*/
    },
     onOk (value) {
      //console.log('onOk: ', value);
    },
    onRangeChange (value, dateString)  {
      //console.log('Selected Time: ', value);
      //console.log('onRangeChange Formatted Selected Time: ', dateString);
      this.start_time_value = dateString[0]
      this.end_time_value = dateString[1]
      //console.log(this.end_time_value)
    },
    openChange(e){
      setTimeout(()=>{
        if(e){
          if(document.getElementsByClassName('ant-picker-ok').length == 1){
            $('<li class="ant-picker-ok"><button class="ant-btn ant-btn-primary ant-btn-sm" onclick="setTodayTime()" type="button"><span>今日零点</span></button></li>').appendTo(".ant-picker-ranges");
          }
        }
      },100)      
    },
    setTodayTime(){
      let start_timestemp = new Date(this.timestr[0]['$d']).getTime();
      let end_timestemp = new Date(this.timestr[1]['$d']).getTime();
      let endtime = moment(end_timestemp).format('YYYY-MM-DD HH:mm:ss')
      let starttime = moment(start_timestemp).format('YYYY-MM-DD HH:mm:ss')
      let obj = ref([dayjs(starttime, this.dateFormat), dayjs(endtime, this.dateFormat)])
      let nowtime = new Date().getTime();
      let itemobj = moment(nowtime).format('YYYY-MM-DD 00:00:00')
      let itemobj2 = dayjs(itemobj, this.dateFormat)
      let itemstempstr = new Date(itemobj).getTime();
      if(this.currentTimeInput == 0) {
        if(itemstempstr > end_timestemp){
          message.error('开始时间不能大于结束时间')
          return;
        }
        obj = ref([itemobj2,dayjs(endtime, this.dateFormat)])
      }else {
        if(itemstempstr < start_timestemp){
          message.error('结束时间不能小于开始时间')
          return;
        }
        obj = ref([dayjs(starttime, this.dateFormat), itemobj2])
      }

      this.timestr = obj
    },
    focusChange(e){
      this.currentTimeInput = this.placeholder.indexOf(e.target.getAttribute('placeholder'))
    },

    onRangeOk (value) {
      console.log('onRangeOk: ', value);
    },
    getKefuact(){
      let that = this;
      
      getKefuCeshi().then(res => {
          if(res.data.length > 0){
            let kefu = [{value:"all",label:'全部'}]
            let kefu2 = [{value:"all",label:'请选择'}]
            res.data.map(function(item){
              let kefitem = {}
              kefitem.value = item.staffName;
              kefitem.label = item.staffName
              kefu.push(kefitem)
              kefu2.push(kefitem)
            })
            that.kefuoptions = kefu
            that.kefuoptions2 = kefu2
          }else {
            that.kefuoptions = [{value:"all",label:'全部'}]
            that.kefuoptions2 = [{value:"all",label:'请选择'}]
          }
          
      })
    },
    getPlanList(){
      let that = this;
      getFeigePlan().then(res => {
        let plan = [{value:"all",label:'请选择'}]
        if(res.data.length > 0){
            res.data.map(function(item){
              let planitem = {}
              planitem.value = item.id;
              planitem.label = item.template_name
              plan.push(planitem)
            })
            that.Planoptions = plan
          }else {
            that.Planoptions = [{value:"all",label:'请选择'}]
          }
      }) 
      
    },
    getRgcp_Renwu_Qs () {
      if(location.href.indexOf('localhost') < 10 && location.href.indexOf('localhost') > 0){
        this.zhenlishuju(this.datas.records);
      }
      this.pageRow = 1;
      this.getRgcp_Renwu_QCeshi()
    },
    settimestr(){
      let end_timestemp = new Date().getTime();
      let start_timestemp = end_timestemp-86400000*3;
      let endtime = moment(end_timestemp).format('YYYY-MM-DD HH:mm:ss')
      let starttime = moment(start_timestemp).format('YYYY-MM-DD HH:mm:ss')
      this.timestr = ref([dayjs(starttime, this.dateFormat), dayjs(endtime, this.dateFormat)])
      this.getRgcp_Renwu_Qs()
    },
    setdatatime(){
        let start_timestemp = new Date(this.timestr[0]['$d']).getTime();
        let endtimestemp = new Date(this.timestr[1]['$d']).getTime();
        
        let data = {}
        data.start_time = parseInt(start_timestemp/1000);
				data.end_time = parseInt(endtimestemp/1000);
        return data;
    },
    zhenlishuju(lists){
		let that = this;
      let items = []
      let xuhao = (this.pageRow-1)*this.pageSize+1
      lists.map(function(item,index){
        let itemitem = item
        itemitem.comment_descstr = itemitem.comment_desc=='true'?'已评论':'未评论';
        itemitem.feige_linkstr = itemitem.feige_link=='true'?'已评论':'未评论';
        itemitem.tel_linkstr = itemitem.tel_link=='true'?'已评论':'未评论';
        itemitem.xuhao = xuhao+index;
        itemitem.kefubeizhu = itemitem.kefubeizhu=='nodata'?'':itemitem.kefubeizhu;      
        itemitem.feige_url = 'https://im.jinritemai.com/pc_seller_v2/main/workspace?fromOrder='+item.parent_order_id
        itemitem.zhu_shop_order_id_url = 'https://fxg.jinritemai.com/ffa/morder/order/detail?id='+item.parent_order_id
        itemitem.jiemiData =  {
			orderId: item.parent_order_id,
			token: that.guanfangToken,
			fields:['phone'],
			style:{width:"130px"},
			innerStyle:{width:"130px"},
			onCopy:function(){
				message.info('已复制')
				let obj = navigator.clipboard.readText()
				obj.then((phone)=>{
					that.tongbufuzhiandxianshi(item.parent_order_id,phone);
				})
				
			},
			fail:function(msg){
				that.cuowutishi(msg.message);
			},
		}
		itemitem.jiemi = Math.random();
        items.push(itemitem)
      })
      this.dataSource = items
    },
	cuowutishi(str){
		message.error(str)
	},
	xinxitishi(str){
		message.info(str)
	},
	tongbufuzhiandxianshi(parent_order_id,phone){
		let data = []
		let bbb = ''
		this.dataSource.map((item)=>{
			if(item.parent_order_id == parent_order_id && item.kefubeizhu.indexOf(phone) == -1){
				bbb = item.kefubeizhu = item.kefubeizhu+','+phone
				item.tel_link = 'true'
			}
			data.push(item);
		})
		this.dataSource = data;
		let orderdata = {
			parent_order_id:parent_order_id,
			value:phone			
		}
		comment_updateTelLinkCeshi(orderdata).then(res=>{})
		if(bbb != ''){
			orderdata.value = bbb;
			comment_updateBeizhuCeshi(orderdata).then(res=>{})
		}
	},
    wanchengxiugaibeizhu(xiugaibeizhustr,id){
      let data = {}
      data.value = xiugaibeizhustr
      data.parent_order_id = id
      comment_updateBeizhuCeshi(data).then(res => {
          message.info(res.data);
      }) 
    },
    getRgcp_Renwu_QCeshi () {
      //this.dataSource = this.datas.records
      //console.log(this.datas.records)
      let that = this;
      let data = this.setdatatime();
      if(data.end_time - data.start_time > 86400*this.timeRange){
        message.error('时间间隔应小于'+this.timeRange+'天')
        return;
      }
      data.remark = this.qizhivalue;
      data.feige_link = this.feigeStatusvalue;
      data.pageRow = this.pageRow;
      if(data.remark == undefined){
        data.remark = 7;
      }
      /*if(document.getElementsByClassName('kefuname').length > 0){
        let kefunameobj = document.getElementById('kefuname');
        this.kefuname = kefunameobj.value;
      }*/
      
      data.cuiping = 'false'
      data.afterSale = 'false'
      data.pageSize = this.pageSize;
      data.parent_order_id = this.parent_order_id==''?'nodata':this.parent_order_id;
      data.product_id = this.product_id==''?'nodata':this.product_id;
      data.staffName =  this.kefuname==''?'all':this.kefuname;
      data.link_status =  this.goutongvalue==undefined?'all':this.goutongvalue;
      data.comment_desc = 'false'
      //data.size = this.pageSize;
      // 调用api接口，并且提供了两个参数               
      getRgcp_Renwu_QCeshi(data).then(res => {
          // 获取数据成功后的其他操作
              //console.log(res)   
              if(res.records.length > 0) {
                that.checklist = []
                that.currentPageTotal = res.records.length
                that.zhenlishuju(res.records);               
                that.paginationtotal = res.total
                that.totalPageNum = res.totalPage;
                that.checkboxchecked=ref(false);
                that.indeterminate=ref(false);
                //console.log('666',that.paginationtotal,that.dataSource)
              }else{
                message.info('未查询到数据')
              }
      })         
    },
    order_getRgcp_Renwu_Q (dataobj) {
      //this.dataSource = this.datas.records
      //console.log(this.datas.records)
      let that = this;
      let data = this.setdatatime();
      if(data.end_time - data.start_time > 86400*this.timeRange){
        message.error('时间间隔应小于'+this.timeRange+'天')
        return false;
      }
      data.remark = this.qizhivalue;
      data.feige_link = this.feigeStatusvalue;
      data.pageRow = this.pageRow;
      if(data.remark == undefined){
        data.remark = 7;
      }
      /*if(document.getElementsByClassName('kefuname').length > 0){
        let kefunameobj = document.getElementById('kefuname');
        this.kefuname = kefunameobj.value;
      }*/
      
      data.cuiping = 'false'
      data.afterSale = 'false'
      data.pageSize = this.pageSize;
      data.parent_order_id = this.parent_order_id==''?'nodata':this.parent_order_id;
      data.product_id = this.product_id==''?'nodata':this.product_id;
      data.staffName =  this.kefuname==''?'all':this.kefuname;
      data.link_status =  this.goutongvalue==undefined?'all':this.goutongvalue;
      data.comment_desc = 'false'
      //data.size = this.pageSize;
      // 调用api接口，并且提供了两个参数               
      order_getRgcp_Renwu_Q(data).then(res => {
        if(res.length == 0){
          message.error('没查询到订单，请修改一下查询条件再试')
          return;
        }
        if(dataobj.fasongtype == 'creatCard'){
          dataobj.orderList = res
          this.finalyaopingAction(dataobj)
        }
        if(dataobj.fasongtype == 'creatfeige'){
          dataobj.orderList = res 
      
          if(typeof(window.apiAPP) == 'undefined'){
            //message.error('请在好评大师使用此功能')
            this.visiblebailing = ref(true);
          }else {
            let res = window.apiAPP.creatfeige(dataobj)
            res.then((datas=>{
              if(datas == CommonConfig.components.bailingVersion){
                this.visiblecreatfeige = ref(true)
                this.fsshijian = ref(5)
                $("#fakefuname").val('all') 
                $("#fafeigePlan").val('all')
              }else {
                this.visiblebailing2 = ref(true);
              }
            }))
          }
        }
      })         
    },
    pillq(){
      let that = this
      let data = this.setdatatime();
      if(data.end_time - data.start_time > 86400*this.timeRange){
        message.error('时间间隔应小于'+this.timeRange+'天')
        return;
      }
      data.remark = this.qizhivalue;
      data.feige_link = this.feigeStatusvalue;
      data.pageRow = this.pageRow;
      data.itemId = this.product_id == ''?'all':this.product_id;
      if(data.remark == undefined){
        data.remark = 7;
      }
      data.cuiping = 'false'
      data.afterSale = 'false'
      getRGCPOrdersSize(data).then(res => {
         that.kelingqunum = res.data;
         that.visiblelingqu = ref(true)
      })
      this.visiblelingqu = ref(true)
    },
    lingquaction(){

      let that = this
      let data = this.setdatatime();
      data.num = this.lingqunum;
      data.staffName = this.lingqukefu;
      if(data.staffName == ''){
        message.error("请输入客服的名称。")
        return;
      }
      if(data.num == '' || data.num == 0){
        message.error("领取条数不能为空或者为0")
        return;
      }
      if(data.num > this.kelingqunum){
        message.error("领取条数不能超过最多可领取条数")
        return;
      }
      if(data.num > 300){
        message.error("领取条数不能超过300条")
        return;
      }
      let regPos = /^\d+$/
      if(!regPos.test(data.num)){
        message.error("领取条数应为纯数字，请修改。")
        return;
      }
      if(data.num < 1){
        message.error("领取条数应大于0，请修改。")
        return;
      }
      data.itemId = this.product_id==''?'all':this.product_id;
      data.cuiping = 'false'
      data.afterSale = 'false'
      data.remark = this.qizhivalue
      data.feige_link = this.feigeStatusvalue;
      if(data.remark == undefined){
        data.remark = 7;
      }
      lingquAll(data).then(res => {
          message.info(res.data)
          that.visiblelingqu = ref(false)
      })
    },
    pildel(){
      let that = this
      let data = {}
      data.order_id_list = '';
      let itemarr = []
      this.dataSource.map(function(item){
        itemarr.push(item.parent_order_id);
      })
      if(itemarr.length == 0){
        message.info('列表没有数据')
        return;
      }
      data.order_id_list = JSON.stringify(itemarr);
      delOrder(data).then(res => {
          message.info(res.data)
      })
    },
    shanchurenwu(parent_order_id){
      let data = {}
      let arr = []
      arr.push(parent_order_id);
      data.order_id_list = JSON.stringify(arr);
      delOrder(data).then(res => {
          message.info(res.data)
      })
    },
    lingqurenwu(parent_order_id){
      this.lingquorder_id = parent_order_id
      this.visiblelingqusigle = ref(true)
    },
    lingqurenwuaction(){
      let that = this
     
      let data = {}
      data.staffName = this.lingqukefu;
      data.parent_order_id = this.lingquorder_id
      data.cuiping = 'false'
      data.afterSale = 'false'
      if(data.staffName == ''){
        message.error("请输入客服的名称。")
        return;
      }
      lingqu(data).then(res => {
          message.info(res.data)
          that.visiblelingqusigle = ref(false)
      })
    },
    
    
    getDecryptTelS(parent_order_id,staffName){
      this.bianchengdone(parent_order_id,'tel_link')
      let that = this;
      let data = {}
      data.parent_order_id = parent_order_id;
      data.staffName = staffName
      comment_getDecryptTel(data).then(res => {
          if(res.data.tel == 'nodata'){
            let url = 'https://fxg.jinritemai.com/ffa/morder/order/detail?tofeige=1&id='+res.data.parent_order_id;
            //clickopen
            let obj = document.getElementById('clickopena');
            obj.href  = url;
            let obj2 = document.getElementById('clickopen');
            obj2.click();
          }else if(!isNaN(res.data.tel)){
            let itemarr = []
            that.dataSource.map(function(item){
              let items = item
              if(item.parent_order_id == res.data.parent_order_id){
                items.tel  = res.data.tel;
                items.iscopy = 'false'
              }
              itemarr.push(items)
            })
            that.dataSource = itemarr;
          }
      })
    },
    copyitems(text){
      var input = document.createElement("input");  
      input.value = text;  
      document.body.appendChild(input); 
      input.select(); 
      document.execCommand("Copy"); 
      document.body.removeChild(input); 
      message.info('已复制')
    },
    copytel(tel,parent_order_id){
      this.copyitems(tel);
      let that = this;
      let itemarr = []
      that.dataSource.map(function(item){
        let items = item
        if(item.parent_order_id == parent_order_id){
          items.iscopy = 'true'
        }
        itemarr.push(items)
      })
      that.dataSource = itemarr;
    },
    copyurl(parent_order_id){
      this.copyitems(parent_order_id)
      let data = {parent_order_id:parent_order_id}
      comment_updateOrderCeshi(data).then(res => {
        console.log(res)
      })
    },
    zhanshilie(value){
      if(value.length<3){
        message.error('表格不能少于3列！')
        return;
      }
      let itemarr = []
      this.oldcolumns.map(function(item){
        if(value.indexOf(item.dataIndex) > -1){
          itemarr.push(item);
        }
      })
      this.columns = itemarr;
    },
    openorderimsuccess(){
      if(this.pilint == 0){
        message.info('消息发送完成！');
        this.visible4 = ref(false);
      }          
      if(this.imorder_id != '' && this.imorder_id != 0) {
        this.updatefeige(this.imorder_id)
      }
      this.sendmessageOn = true; 
    },
    openorderimfail(msg){
      this.sendmessageOn = true;
      message.error(msg);
      if(this.pilint != 0){
        clearInterval(this.pilint)
        this.visible4 = ref(false)
      }
      return;
    },
    bianchengdone(parent_order_id,type){
      let datalist = []
      this.dataSource.map(item => {
        if(item.parent_order_id == parent_order_id){
          item[type] = 'true'
        }
        datalist.push(item)
      })
      this.dataSource = datalist
    },
    updatefeige(parent_order_id){
      this.bianchengdone(parent_order_id,'feige_link')
      let data={parent_order_id:parent_order_id}
      comment_updateFeigeCeshi(data).then(res=>{
        console.log(res)
      })
      
    },
    setImContent(parent_order_id){
      let imorder_idobj = document.getElementsByClassName('imorder_id')
      if(imorder_idobj.length == 0){
        this.$router.push('/PluginEdu')
        return;
      }
      
      let chromepluginversion = document.getElementsByClassName('chromepluginversion')
      if(chromepluginversion.length == 0)  {
        this.$router.push('/PluginEdu')
        return;
      }
      if(chromepluginversion[0].value != CommonConfig.components.chromepluginversion){
        this.$router.push('/PluginEdu')
        return;
      }
      if(!this.sendmessageOn){
        message.info('有正在发送中的消息，请稍后再试！');
        return;
      }
      this.imorder_id = parent_order_id;
      this.visible2 = ref(true);
    },
    openorderim(){
      this.sendmessageOn = false;
      if(this.pilint == 0){
        message.info('消息发送中，请稍后！');
      }
      
      let imorder_id = document.getElementById('imorder_id');
      imorder_id.value = this.imorder_id;	
      let fasong_content = document.getElementById('fasong_content');
      fasong_content.value = this.fasong_content;	
    },
    checkboxchange(e){
      let arr = this.checklist
      if(e.target.checked ){
        arr.push(e.target.value)        
      }else {
        let itemarr = []
        arr.map(function(item){
          if(item != e.target.value){
            itemarr.push(item);
          }
        })
        arr = itemarr
      }
      let newarr = [...new Set(arr)]
      if(newarr.length == this.currentPageTotal && this.currentPageTotal > 0){
        
        this.checkboxchecked = ref(true);
        this.indeterminate  = ref(false);
      }else if(newarr.length == 0 || newarr.length == '0') {
        this.checkboxchecked = ref(false);
        this.indeterminate  = ref(false);
      }else {
        this.checkboxchecked = ref(false);
        this.indeterminate  = ref(true);
      }
      this.checklist = newarr;
      let itemarr2 = []
      this.dataSource.map(function(item){
        let item2 = item
        if(item.parent_order_id == e.target.value){
          item2.checked = ref(e.target.checked);
        }
        itemarr2.push(item2)
      })
      this.dataSource = itemarr2
    },
    checkAllchange(e){   
      if(e.target.checked){
        let checkarr = []
        this.dataSource.map(function(item){
          checkarr.push(item.parent_order_id);
        })
        this.checklist = [...new Set(checkarr)];
        this.checkboxchecked = ref(true);
        this.indeterminate  = ref(false);
      }else {
        this.checklist = [];
        this.checkboxchecked = ref(false);
        this.indeterminate  = ref(false);
      }
      let itemarr = []
      this.dataSource.map(function(item){
        item.checked = ref(e.target.checked);
        itemarr.push(item)
      }) 
      this.dataSource = itemarr
    },
    piliangfeigemsg(){
      if(typeof(window.apiAPP) == 'undefined'){
        this.visiblebailing = ref(true);
        return;
      }
      if(this.Planoptions.length <= 1){
        this.NoPlanvisible = ref(true)
        return;
      }      
      this.visible3 = ref(true);

    },
    piliangfeigemsg2(){
      if(this.pilint != 0){
        this.visible4 = ref(true)
        return;
      }
      let imorder_idobj = document.getElementsByClassName('imorder_id')
      if(imorder_idobj.length == 0){
        this.$router.push('/PluginEdu')
        return;
      }
      let chromepluginversion = document.getElementsByClassName('chromepluginversion')
      if(chromepluginversion.length == 0)  {
        this.$router.push('/PluginEdu')
        return;
      }
      if(chromepluginversion[0].value != CommonConfig.components.chromepluginversion){
        this.$router.push('/PluginEdu')
        return;
      }
      if(!this.sendmessageOn){
        message.info('有正在发送中的消息，请稍后再试！');
        return;
      }
      if(this.checklist.length == 0){
        message.error('请在左侧勾选要发送信息的订单')
        return;
      }
      //this.imorder_id = parent_order_id;
      this.visible31 = ref(true);

    },
    handleOk(){
      this.visible = ref(false);
    },
    handleOk2(){
      if(this.fasong_content == ''){
        message.error('请输入要发送的内容！');
        return;
      }
      this.visible2 = ref(false);
      this.openorderim();
    },
    handleOk3(){
      let staffName  = document.getElementById('fakefuname').value;
      let template_id = document.getElementById('fafeigePlan').value;
      //let auto=this.messageOrderValue;
      let orderList = [];    //parent_order_id=11111
      if(staffName == 'all'){
        message.error('请选择客服')
        return;
      }
      if(template_id == 'all'){
        message.error('请选择消息模板')
        return;
      }
       
      
      this.visible3 = ref(false);
      let data = {}
      data.listtype = this.messageOrderValue
      data.timer = this.fsshijian;
      
      data.template_id = template_id
      data.staffName = staffName
      data.orderList = orderList 
      data.shopId = window.shopinfoObj.id;  
      if(data.timer < 5){
        message.error('发送间隔不能低于5秒')
        return;
      }
      if(this.messageOrderValue == 'selectList'){
        if(this.checklist.length == 0){
          message.error('请在左侧勾选要发送信息的订单')
          return;
        }else {
          this.checklist.map((item)=>{
            let itemobj = {}
            itemobj.parent_order_id = item
            //orderList.push(itemobj)
            orderList.push(item)
          })
        }       
      } else {
        data.fasongtype = 'creatfeige'
        orderList = this.order_getRgcp_Renwu_Q(data);
        return;
        
      }  
      data.orderList = orderList 
      
      if(typeof(window.apiAPP) == 'undefined'){
        //message.error('请在好评大师使用此功能')
        this.visiblebailing = ref(true);
      }else {
        let res = window.apiAPP.creatfeige(data)
        res.then((data=>{
          if(data == CommonConfig.components.bailingVersion){
            this.visiblecreatfeige = ref(true)
            this.fsshijian = ref(5)
            $("#fakefuname").val('all') 
            $("#fafeigePlan").val('all')
          }else {
            this.visiblebailing2 = ref(true);
          }
        }))
      }
      /*this.Planoptions.map(item=>{
        if(item.value == template_id){
          data.template_name = item.label;
        }
      })
      addFeigeOrder(data).then(res=>{
        if(res.success == true || res.success == 'true'){
          
          this.visible6 = ref(true);
          
        }else {
          message.error("请稍后再试")
        }
      })*/
      
    },
    closevisiblecreatfeige(){
      this.visiblecreatfeige = ref(false)
    },
    handleOk4(){
      this.visible4 = ref(false);
    },
    handleOk31(){
      if(this.fasong_content == ''){
        message.error('请输入要发送的内容！');
        return;
      }
      
      this.visible31 = ref(false);
      let that = this;
      let pilnum = this.checklist.length;
      let i = 0;
      this.pilnum = pilnum;
      that.visible4 = ref(true);

      this.pilint = setInterval(() => {
        if(this.sendmessageOn){
          that.imorder_id = that.checklist[i]
          that.openorderim();
          i = i+1;
          that.fpilnum = i;
          if(i==pilnum){
            clearInterval(that.pilint);
            that.pilint = 0;
            //that.visible4 = ref(false);
          }
        }
      }, 500);
    },
    handleOk5(){
      this.visible5 = ref(false)
      this.$router.push('/RengongBailing')
      return;
      
    },
    handleOk6(){
      this.visible6 = ref(false);
    },
    handleOkNoPlan(){
      this.NoPlanvisible = ref(false);
      this.$router.push('/RengongFeigeMessageList')
    },
    piliangbeizhu(){
      if(this.dataSource.length == 0){
        message.info('列表没有数据！')
        return;
      }
      this.beizhuvisible = ref(true);
    },
    piliangbeizhuAct(){
      
      this.beizhuvisible = ref(false);
      let data = {}
      data.value = this.plbeizhustr;
      let lists = []
      let itemsource = []
      this.dataSource.map(item=> {
        let kefubeizhu = item.kefubeizhu
        if(kefubeizhu == 'nodata' || kefubeizhu == '' || kefubeizhu == undefined){
          lists.push(item.parent_order_id);
          item.kefubeizhu = data.value
        }
        itemsource.push(item)
      })      
      data.listOrder = JSON.stringify(lists);
      comment_PLupdateBeizhuCeshi(data).then(res=>{
        if(res.success){
          message.info(res.data)
          this.dataSource = itemsource
        }else {
          message.info('请稍后再试！')
        }
      })

    },
    handleOkbailing(){
      this.visiblebailing = ref(false)
      this.visiblebailing2 = ref(false)      
      let url = CommonConfig.components.bailingInfourl;
      let obj = document.getElementById('clickopena');
      obj.href  = url;
      let obj2 = document.getElementById('clickopen');
      obj2.click();
    },
    deleteMul(){
      this.deletevisible = ref(true);
    },
    piliangdelAct(){
      this.deletevisible = ref(false);
      if(this.checklist.length == 0){
        message.error('请在列表左侧勾选要删除的订单')
        return;
      }
      message.info('删除中......')
      let lists = JSON.stringify(this.checklist)
      let data = {orderList: lists};
      paichu_delOrderCeshi(data).then(res => {
        message.info('已删除')
      })
    },
    async huoqumsgimg(e){
      console.log(e)
      
      let file = e.target;
      /*const reader = new FileReader();
      let _this = this
      reader.onload = (file) => {
        const img = new Image();
        img.src = file.target.result;
        img.onload = () => {
          let base64 = _this.imageBase64(img);
          console.log(base64)
          let blob = _this.base64ToBlob(base64.replace("data:image/png;base64,", ""), "image/png");
          navigator.clipboard.write([
            new ClipboardItem({
              "image/png": blob,
            }),
          ]);
        };
      };
      reader.readAsDataURL(file.files[0]);*/
      let image = '';
      if (!file.files || !file.files[0]) {
          console.log('file!=image  e')
            return;
        }
        var reader = new FileReader();
        let _this = this
        reader.onload = async function (evt) {
            document.getElementById('msgimgview').src = evt.target.result;
            image = evt.target.result;
            let type = image.substring(5,image.indexOf('base64,')-1)
            _this.parseBase64toBlob(image,type)
        }
        reader.readAsDataURL(file.files[0]);
        
        
    },

    imageBase64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/gif");
      return dataURL;
    },
    async parseBase64toBlob(base64,type) {
      let image2 = base64.substring(base64.indexOf('base64,')+7)
      let blob = this.base64toBlob(image2,type)
      console.log(blob)
      await navigator.clipboard.write([new ClipboardItem({ [type]: blob })])
    },
   /* base64toBlob(base64, type = 'application/octet-stream') {
      const bstr = atob(base64);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type });
    }*/

    base64ToBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      var byteCharacters = window.atob(b64Data);
      // var byteCharacters  = b64Data;
      // 该atob函数将base64编码的字符串解码为一个新字符串，其中包含二进制数据每个字节的字符。
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        // 通过使用.charCodeAt字符串中每个字符的方法应用它来创建一个字节值数组。
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        // 将此字节值数组转换为实际类型的字节数组，方法是将其传递给Uint8Array构造函数。
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      // 创建一个blob：包含此数据的URL，并将其显示给用户。
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
	tan_goodPldownloadACT(){
		let val = this.tan_goodPldownloadACTValue;
		this.tan_goodPldownloadvisible = false;
		if(val == 'check'){
			this.goodPldownload();
		}else {
			let that = this;
			let data = this.setdatatime();
			if(data.end_time - data.start_time > 86400*this.timeRange){
				message.error('时间间隔应小于'+this.timeRange+'天')
				return;
			}
			data.remark = this.qizhivalue;
			data.feige_link = this.feigeStatusvalue;
			data.pageRow = this.pageRow;
			if(data.remark == undefined){
				data.remark = 7;
			}
			/*if(document.getElementsByClassName('kefuname').length > 0){
				let kefunameobj = document.getElementById('kefuname');
				this.kefuname = kefunameobj.value;
			}*/

			data.cuiping = 'false'
			data.afterSale = 'false'
			data.pageSize = this.pageSize;
			data.parent_order_id = this.parent_order_id==''?'nodata':this.parent_order_id;
			data.product_id = this.product_id==''?'nodata':this.product_id;
			data.staffName =  this.kefuname==''?'all':this.kefuname;
			data.link_status =  this.goutongvalue==undefined?'all':this.goutongvalue;
			data.comment_desc = 'false'
			this.exportExcelgetOrderDown('/assess/yewu/indent/job/downWorkOrderAll.do',data)
		}
	},
	tan_goodPldownload(){
		this.tan_goodPldownloadvisible = true;
	},
    goodPldownload(){
      let data = []
      if(this.checklist.length == 0){
        message.error('请在左侧勾选要下载的订单')
        return;
      }else {
        this.checklist.map((item)=>{          
          data.push(item)
        })
      }
      this.exportExcel('/assess/yewu/indent/job/setDownOrder.do',data)
    },
	exportExcelgetOrderDown(url, data){
		try {
			var exportForm = $("<form action='" + url + "' method='post'></form>")
			for(let key in data){
				exportForm.append("<input type='hidden' name='" + key + "' value='" + data[key] + "'/>")
			}
			$(document.body).append(exportForm);
			exportForm.submit();
		} catch (e) {
			console.log(e);
		} finally {
			exportForm.remove();
		}
    },
    exportExcel(url, data){
      try {
          var str = encodeURIComponent(JSON.stringify(data))
					var exportForm = $("<form action='" + url + "' method='post'></form>")
					exportForm.append("<input type='hidden' name='orderList' value='" + str + "'/>")
					$(document.body).append(exportForm);
					exportForm.submit();
				} catch (e) {
					console.log(e);
				} finally {
					exportForm.remove();
				}
    },
    
    yaopingAction(parent_order_id){
      if(typeof(window.apiAPP) == 'undefined'){
        this.visiblebailing = ref(true);
        return
      }
      if(parent_order_id == 'all'){
        this.plyaopingAct()
      }else {
        let keyi = false;
        this.dataSource.map((item)=>{
          if(item.parent_order_id == parent_order_id && item.confirm_receipt_time != 0 && item.confirm_receipt_time != '0'){
            keyi = true;
          }
        })
        if(!keyi){
          message.error('只有确认收货的订单才可以发送邀评消息');
          return;
        }
        let data = {};
        data.orderList = [parent_order_id]
        data.listtype = 'selectList'
        this.finalyaopingAction(data)
      }
    },
    finalyaopingAction(data){
      //console.log(data)
      data.shopId = window.shopinfoObj.id
      if(typeof(window.apiAPP) == 'undefined'){
        //message.error('请在好评大师使用此功能')
        this.visiblebailing = ref(true);
      }else {
        let res = window.apiAPP.creatCard(data)
        res.then((data=>{
          if(data == CommonConfig.components.bailingVersion){
            message.info('开始邀评')
          }else {
            this.visiblebailing2 = ref(true);
          }
        }))
      }
    },    
    piliangyaoping(){
      this.visibleYaoping = ref(false);
      let yaopingValue = this.yaopingValue; 
      let arrlist = []
      let data = {};
      data.listtype = yaopingValue
      if(yaopingValue == 'selectList'){
        if(this.checklist.length == 0){
          message.error('请在左侧勾选订单')
          return;
        }
        arrlist = Array.from(this.checklist);
      }else {
        data.fasongtype = 'creatCard'
        arrlist = this.order_getRgcp_Renwu_Q(data);
        return;
        
      }
      data.orderList = arrlist
      this.finalyaopingAction(data)
    },
    plyaopingAct(){
      this.visibleYaoping = ref(true);
    },
    paichufasong(id){
      paichu_delOrderCeshi({orderList:'['+id+']'}).then(res=>{
        message.info('已删除')
      })
    },
	lianjiedayinji(){
		this.ws = new WebSocket("ws://localhost:13888"); 
		let that = this;
		this.ws.onopen = function(){
			this.lianjiedayinjistatus = true;
			let uuids = that.uuid();
			that.ws.send('{"cmd": "getPrinters","requestID": "'+uuids+'","version": "1.0"}');
		}
		this.ws.onmessage = function(e){
			let data = JSON.parse(e.data);
			if(data.cmd == 'getPrinters'){
				let arr = [{value:'all',name:'请选择'}];
				data.printers.map(function(item){
					let obj = {};
					obj.name = item.name
					obj.value = item.name
					arr.push(obj)
				})
				that.Printeroptions = arr
			}
			
	
		}
		this.ws.onclose = function(e){
			message.error('请打开抖店打印组件,或者点弹窗中的下载链接去下载安装')
			this.lianjiedayinjistatus = false;
			console.log("close");
		}
		this.ws.onerror = function(e){
			/*console.log("onerror");			
			*/
		}
	},
	piliangPrintOrder(status,id){
		this.piliangPrintOrderStatus = status;
		this.yulanValue = false;
		if(status == false)this.yulandayinid = id;
		if(this.lianjiedayinjistatus != true){
			this.lianjiedayinji();
		}		
		this.visiblePrintOrder = true;
		
	},
	yulan(id){
		this.yulandayinid = id;
		this.piliangPrintOrderStatus = false;
		this.yulanValue = true;
		if(this.lianjiedayinjistatus != true){
			this.lianjiedayinji();
		}		
		this.visiblePrintOrder = true;
	},
	uuid() {
		const tempUrl = URL.createObjectURL(new Blob());
		const uuid = tempUrl.toString();
		URL.revokeObjectURL(tempUrl);
		return uuid.substring(uuid.lastIndexOf("/") + 1);
	},
	closepiliangPrint(){
		this.visiblePrintOrderData = ref(false);
	},
	piliangPrintOrderAct(){
		let data = {}
		let printervalue = document.getElementById('Printeroptions').value
		if(printervalue == 'all' || printervalue == '请选择'){
			message.error('请开启或下载安装抖店打印组件')
			return;
		}
		data.printer = printervalue;
		let templatevalue = document.getElementById('kuaidiTempoptions').value
		let templateUrl = '';
		this.kuaidiTempoptions.map(item=>{
			if(templatevalue == item.template_code){
				data.template = JSON.stringify(item);
			}
		})
		
		let fhrid = document.getElementById('fahuoRenoptions').value
		if(fhrid == 'all'){
			message.error('请编辑选择发货人')
			return;
		}
		let sendinfo = {}
		this.fahuoRenoptions.map(item=>{
			if(fhrid == item.id){
				sendinfo = item;
			}
		})
		
		
		data.sendinfo = JSON.stringify(sendinfo);
		data.preview = this.yulanValue?'true':'false';
		if(this.piliangPrintOrderStatus){
			if(this.checklist.length == 0){
				message.error('请在左侧勾选订单')
				return;
			}
			let arrlist = Array.from(this.checklist);
			//data.orderList = JSON.stringify(arrlist);
      this.orderListNum = 0;
      message.info('开始打印，请等待')
      this.tijiaodayinshuju(data);

		}else {
      let arr = []
      arr.push(this.yulandayinid)
			data.orderList = JSON.stringify(arr);
      let that = this;
      tijiaoprint(data).then(res=>{
        this.visiblePrintOrder = false;
        if(res.data != 'true' && res.data != '' && res.data != null && res.data != undefined){
          this.visiblePrintOrderData = ref(true);
          this.PrintOrderData = res.data;
        }        
        if(res.printInfoArray.length > 0){
          res.printInfoArray.map(item=>{
            that.ws.send(item)
          })
        }
      })
		}
	},
	chunkArray(array, chunkSize) {
		let chunks = [];
		for (let i = 0; i < array.length; i += chunkSize) {
			chunks.push(array.slice(i, i + chunkSize));
		}
		return chunks;
	},
	tijiaodayinshuju(data){
		let arr = []
		let that = this;
		let resarr = this.chunkArray(this.checklist, 10);
		resarr.map(item => {
			data.orderList = JSON.stringify(item);
			tijiaoprint(data).then(res=>{
				that.visiblePrintOrder = false;
				if(res.data == 'true'){
					if(res.printInfoArray.length > 0){
						res.printInfoArray.map(item=>{
							that.ws.send(item)
						})
					}
				}else {
					that.visiblePrintOrderData = ref(true);
					that.PrintOrderData = res.data;
					return;
				}
			})
		})
	},
	getTempleteList(){
		//test
		let obj = [{"template_id":6,"template_code":"zt_100_180_v2","template_name":"中通二联单","template_url":"https://lf6-cm.ecombdstatic.com/obj/logistics-davinci/template/template_zhongtong100.xml","version":1,"template_type":2,"perview_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/preview/zt_100_180.png","logistics_code":"zhongtong"},{"template_id":5,"template_code":"zt_76_130_v2","template_name":"中通一联单","template_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/template/v2/zhongtong_76_130.xml","version":1,"template_type":1,"perview_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/preview/v2/zt_76_130.png","logistics_code":"zhongtong"},{"template_id":8,"template_code":"yd_100_180_v2","template_name":"韵达二联单","template_url":"https://lf6-cm.ecombdstatic.com/obj/logistics-davinci/template/template_100.xml","version":1,"template_type":2,"perview_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/preview/yd_100_180.png","logistics_code":"yunda"},{"template_id":7,"template_code":"yd_76_130_v2","template_name":"韵达一联单","template_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/template/v2/yunda_76_130.xml","version":1,"template_type":1,"perview_url":"https://lf3-cm.ecombdstatic.com/obj/logistics-davinci/preview/v2/yd_76_130.png","logistics_code":"yunda"}]
		if(location.href.indexOf('localhost') > 0){
			this.kuaidiTempoptions = obj;
		}
		getPrTemplateNEW().then(res=>{
			this.kuaidiTempoptions = res;
		})
	},
	
    getfhinfo(){ 
		getPrSendInfoNEW().then(res => {
			let val = [{id:'all',sendName:'请选择'},...res.data]
			this.fahuoRenoptions = val;			
		})
    },
	piliangduanxin(){
		let that = this;
		this.fasongduanxinAct = false;
		if(that.checklist.length == 0){
			message.info('请选择订单')
			return;
		}
		this.visibleSmsTemp = true;
	},
	piliangSmsAct(){
		let that = this;
		let data = {}
		if(this.fasongduanxinAct){
			let arr = []
			arr.push(that.fasongduanxinActID);
			data.orderList = JSON.stringify(Array.from(arr));
		}else {
			if(that.checklist.length == 0){
				message.info('请选择订单')
				return;
			}
			data.orderList = JSON.stringify(Array.from(that.checklist));
		}
			
		
		let id = this.setduanxin		
		data.template_id = id;
		data.smsName = this.setduanxinSms;
		if(id == '' || data.smsName == ''){
			message.error('请选择短信模板和签名')
			return;
		}
		this.visibleSmsTemp = false;
		sendOrder(data).then(res => {
			message.info('开始发送');
		})
	},
	fasongduanxin(id){
		this.visibleSmsTemp = true;
		this.fasongduanxinAct = true;
		this.fasongduanxinActID = id;			
	},
	gotosmstemp(){
		this.$router.push('/SmsTemplate')
	},
	gotosmssign(){
		this.$router.push('/SmsSign')
	},
    setduanxinAct(){
      let templateId = this.setduanxin 
      let shopName = this.setduanxinSms
		if(shopName == '' || shopName == null){
			message.info('请先选择一个签名');
			return;
		}
		this.shopName = shopName;
      let that = this;
      this.duanxinlist.map(item=>{
        if(item.sms_template_id == templateId){
			that.wenbentext = item.template_content;
			that.sms_template_name = item.template_name
        }
      })
    },
    chakanjiaocheng(){
      this.jiaochengbisible=ref(true)
    },
    closeModal(){
      this.jiaochengbisible = ref(false)
      this.provisible = ref(false)
    },
  }
});
</script>
<style>
.inlineblock {
  width:251px; 
  margin-right: 8px;
}
.ant-input-group-addon {
  color:#898b8f;
}
.tableClass {
  cursor: pointer;
}
.paginationdiv {
  text-align: right;
  margin-top: 8px;
}
.zongshuspan {
  margin-left: 8px;
}
.zongshu{
  color: rgb(24, 144, 255);
  font-size: 16px;
  margin: 0 2px;
}
</style>
